import React, {useEffect, useState} from 'react';
import axios from "axios";
import Parser from "html-react-parser";
import ContactModal from "../ContactModal";
import {motion} from "framer-motion";

const CTAPageFormation = ({formationId, data}) => {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const [ctaData, setCtaData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get( `${apiUrl}/front_pages?type=14`);
                setCtaData(response.data);
                setLoading(false)
            } catch (error) {
                console.error('Erreur lors de la récupération des données :', error);
            }
        };

        fetchData();
    }, [apiUrl]);

    return (
        <section className='cta-formation'>
            {!loading && ctaData?.map((home, homeIndex) => (
                    <React.Fragment key={homeIndex}>
                        {home?.frontPageContainers?.map((container, containerIndex) => (
                            container?.demandeInformation && (
                                <div className={'auto-container'}>
                                    <div className={'row'}>
                                        <div className={'cta-formation-content'} key={containerIndex}>
                                            <div className={'cta-formation-title'}>
                                                <h2 className={'petit'}>{Parser(container.titre)}</h2>
                                                <span>{Parser(container.description)}</span>
                                            </div>

                                            <motion.div
                                                className={'d-flex flex-row gap-2'}
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ delay: 1.0, duration: 0.5 }}
                                            >
                                                {data.ficheFormation.lien ? (
                                                    <a target={'_blank'} rel={'noreferrer'} href={data.ficheFormation.lien}
                                                       className={'theme-btn btn-style-one small d-flex flex-row justify-content-center align-items-center gap-1'}>
                                                        <i className={'cta-icons icon-Brochure-catalogue'}/>
                                                        Téléchargez la fiche formation
                                                    </a>
                                                ): ''}

                                                <ContactModal
                                                    formationId={formationId}
                                                    formationName={data.titre}
                                                    type={1}
                                                    textButton="Demander des informations personnalisées"
                                                    defaultSkin={'btn-style-one small'}
                                                />
                                            </motion.div>
                                        </div>
                                    </div>
                                </div>
                            )
                        ))}
                    </React.Fragment>
                ))}
        </section>
    );
};

export default CTAPageFormation;
